export function dateVersion(date: Date = new Date()): string {
  return [date.getFullYear() % 100, date.getMonth() + 1, date.getDate()].join('.');
}

export const version = `${dateVersion()}-local`;
